import ColorAttributeValueEditor from "./ColorAttributeValueEditor.js";
import ColorNameEditor from "./ColorNameEditor.js";
export default {
  install(molten) {
    molten.addPlugin('AttributeValueEditor', ColorAttributeValueEditor);
    molten.addPlugin('AttributeValueEditor', {
      name: 'assetLocators.colorName',
      objectType: 'assetLocators',
      getOptions: usage => {
        return {
          embed: true,
          isRenderer: false
        };
      },
      create: ColorNameEditor
    });
  }
};